export const TYPES_SERVICES = [
  {id: 0, description: "Aucun"}, 
  {id: 1, description: "Autre"}, 
  {id: 2, description: "Eau"}, 
  {id: 3, description: "Égouts"}, 
  {id: 4, description: "Électricité"}, 
]

export const TYPE_AMPERAGES = [
  {id: 0, description: "N/A"}, 
  {id: 1, description: "15 Amps"}, 
  {id: 2, description: "20 Amps"}, 
  {id: 3, description: "30 Amps"}, 
  {id: 4, description: "50 Amps"}, 
  {id: 5, description: "100 Amps"}, 
]